import { useState } from 'react';
import { toast } from 'sonner';
import { ApiError } from '@/api/client';

/**
 * Route a rejected save into per-field messages.
 *
 * The API answers a failed validation with `details` keyed by field name. Wiring
 * that through to the input it belongs to is the difference between "Some fields
 * need attention" and the person actually knowing that the state box wants `NY`
 * rather than `New York`.
 */
export function useFieldErrors() {
  const [fieldErrors, setFieldErrors] = useState({});

  const handleError = (error, fallbackMessage) => {
    if (error instanceof ApiError && error.details) {
      setFieldErrors(error.details);
      toast.error(error.message);
      return;
    }

    setFieldErrors({});
    toast.error(error?.message ?? fallbackMessage ?? 'Something went wrong');
  };

  return { fieldErrors, setFieldErrors, handleError, clearErrors: () => setFieldErrors({}) };
}

/** Red ring on an input the server rejected. */
export function errorClass(message) {
  return message ? 'border-red-300 focus-visible:ring-red-400' : '';
}
